/* INNOR — fiche produit : consentement de précommande.

   Le drop RONIN se vend avant d'exister. Le client n'achète donc pas un
   objet en stock mais une promesse de livraison, et il doit l'accepter
   expressément AVANT de payer — pas la découvrir dans un e-mail de
   confirmation.

   Trois choses, dans cet ordre :

   1. Rien ne part au panier tant que la case n'est pas cochée. Le bouton
      reste CLIQUABLE (il n'est pas désactivé) : un bouton grisé ne dit pas
      pourquoi il l'est. Cliquer sans avoir coché affiche la raison et
      ramène l'attention sur la case.

   2. Le paiement express (Apple Pay / Shop Pay…) est neutralisé par une
      couche posée par-dessus. Impossible de l'intercepter proprement : ces
      boutons vivent dans une iframe Shopify et emmènent directement au
      paiement. Un clic dessus sauterait le consentement — donc on bloque
      l'accès physique tant que la case n'est pas cochée.

   3. L'accord est HORODATÉ dans une propriété de ligne, qui suit la
      commande. Un consentement sans trace n'existe pas le jour où il faut
      le prouver.

   Le champ [data-consent-stamp] est un input du formulaire produit : il
   part donc naturellement avec l'ajout au panier (innor-core.js lit les
   properties[…] du formulaire), et innor-ensemble.js le recopie sur chaque
   ligne de l'ensemble. */
(function () {
  'use strict';
  /* Chargé par le tiroir panier sur toutes les pages, et par la page panier :
     la garde évite de lier deux fois les mêmes cases. */
  if (window.__innorPreorder) return;
  window.__innorPreorder = true;

  var MSG = 'Cochez la case pour accepter les conditions de précommande.';

  function stampText() {
    var now = new Date();
    function two(n) { return n < 10 ? '0' + n : String(n); }
    return 'Acceptées le ' + two(now.getDate()) + '/' + two(now.getMonth() + 1) + '/' +
      now.getFullYear() + ' à ' + two(now.getHours()) + 'h' + two(now.getMinutes());
  }

  function bind(root) {
    var check = root.querySelector('[data-preorder-consent]');
    if (!check) return;

    var form = check.closest('form');
    var stamp = form ? form.querySelector('[data-consent-stamp]') : null;
    var errorEl = form ? form.querySelector('[data-form-error]') : null;
    var express = form ? form.querySelector('[data-express]') : null;
    var lock = form ? form.querySelector('[data-express-lock]') : null;

    /* Case masquée (panier de jupe seule, en stock) : rien à accepter. */
    function sansConsentement() {
      return !!check.closest('[hidden]');
    }

    function refuse() {
      /* Le message s'écrit là où le visiteur regarde : sous le bouton qu'il
         vient de cliquer. Les deux parcours (pièce seule, ensemble) ont leur
         propre ligne d'erreur, on remplit les deux plutôt que de deviner. */
      var ensembleError = document.querySelector('[data-ensemble-error]');
      if (ensembleError) ensembleError.textContent = MSG;
      if (errorEl) errorEl.textContent = MSG;
      root.classList.add('is-required');
      /* La case peut être HORS DU CHAMP : dans le tiroir panier elle défile
         avec la commande, et le bouton refusé, lui, est fixé en bas. Sans ce
         rappel à l'écran, le clic ne produirait rien de visible. On ramène
         d'abord, on met le focus ensuite (d'où preventScroll, qui empêche le
         navigateur de refaire un second saut sec par-dessus l'animation). */
      if (root.scrollIntoView) {
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      check.focus({ preventScroll: true });
      /* La classe est retirée à la fin de l'animation pour pouvoir la
         rejouer au clic suivant — sans quoi le second refus ne bouge plus. */
      setTimeout(function () { root.classList.remove('is-required'); }, 700);
    }

    function sync() {
      var ok = check.checked;
      root.classList.toggle('is-accepted', ok);
      if (express) express.classList.toggle('is-locked', !ok);
      if (lock) lock.hidden = ok;
      /* L'horodatage n'est posé qu'au moment où la case est cochée, et
         effacé si elle est décochée : la commande ne doit jamais porter un
         accord qui n'a pas été donné. */
      if (stamp) stamp.value = ok ? stampText() : '';
      if (ok) {
        [errorEl, document.querySelector('[data-ensemble-error]')].forEach(function (el) {
          if (el && el.textContent === MSG) el.textContent = '';
        });
      }
    }

    check.addEventListener('change', sync);

    /* Ajout au panier de la pièce seule : on intercepte en phase de CAPTURE,
       avant le gestionnaire d'innor-core.js, sinon la ligne serait déjà
       partie quand on découvre que la case n'est pas cochée. */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (check.checked || sansConsentement()) return;
        /* Sur la page panier, le même formulaire sert à DEUX choses : mettre à
           jour une quantité et passer commande. Seul l'achat est conditionné —
           bloquer la mise à jour empêcherait de corriger son panier tant qu'on
           n'a pas accepté, ce qui n'a aucun sens. Le nom du bouton qui a
           déclenché l'envoi fait la différence. */
        if (e.submitter && e.submitter.name === 'update') return;
        e.preventDefault();
        e.stopPropagation();
        refuse();
      }, true);
    }

    if (lock) {
      lock.addEventListener('click', function (e) {
        e.preventDefault();
        refuse();
      });
    }

    /* Le CTA de l'ensemble vit hors du formulaire (il constitue le panier
       lui-même) : même verrou, même message.

       MAIS SEULEMENT DEPUIS LA FICHE PRODUIT. Depuis le 15/08 le panneau
       panier porte lui aussi un bloc [data-preorder], et il est rendu sur
       TOUTES les pages. Sur une fiche produit, bind() tournait donc deux fois
       et posait deux verrous sur le MÊME bouton d'ensemble. Celui du panneau,
       dont la case n'est jamais cochée à ce moment-là, refusait l'ajout — et
       le client voyait « cochez la case » alors qu'il venait de la cocher.
       Bug constaté par le client, corrigé ici. */
    if (root.closest('[data-cart-panel]')) return;

    var ensembleCta = document.querySelector('[data-ensemble-cta]');
    if (ensembleCta) {
      ensembleCta.addEventListener('click', function (e) {
        if (check.checked) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        refuse();
      }, true);
    }

    sync();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-preorder]').forEach(bind);
  });
})();
